module.exports = __webpack_public_path__ + "img/t3-headshot.91ecbda1.png";